var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orion_certificate 1",
    clipPath: "url(#clip0_472_673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M15.5948 14.5719V3.16779C15.5948 2.49567 15.3319 1.85107 14.864 1.37581C14.3961 0.900545 13.7614 0.633545 13.0997 0.633545H2.86963C4.24195 0.633545 4.99049 1.77396 4.99049 3.16779V17.1062C4.99049 17.7783 5.25337 18.4229 5.72129 18.8981C6.18922 19.3734 6.82387 19.6404 7.48562 19.6404",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer2_2",
    d: "M2.86964 0.633545C1.49732 0.633545 0.624023 1.77396 0.624023 3.16779H4.9905M16.8424 14.5719H7.48563C8.14738 14.5719 8.78202 14.8389 9.24995 15.3142C9.71788 15.7894 9.98076 16.434 9.98076 17.1062C9.98076 17.7783 9.71788 18.4229 9.24995 18.8981C8.78202 19.3734 8.14738 19.6404 7.48563 19.6404H16.8424C17.5041 19.6404 18.1388 19.3734 18.6067 18.8981C19.0746 18.4229 19.3375 17.7783 19.3375 17.1062C19.3375 16.434 19.0746 15.7894 18.6067 15.3142C18.1388 14.8389 17.5041 14.5719 16.8424 14.5719Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M8.10938 10.7706H12.4759M8.10938 4.43494H12.4759H8.10938ZM8.10938 7.60275H12.4759H8.10938Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.961,
    height: 20.274,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuery);
export default __webpack_public_path__ + "static/media/Query.3487c9e7f7a6b19f18d995b93a0dbc82.svg";
export { ForwardRef as ReactComponent };